import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "data" }
const _hoisted_2 = { class: "middle-content" }
const _hoisted_3 = { class: "date-info" }
const _hoisted_4 = { class: "date-info" }
const _hoisted_5 = { class: "footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["CommonModal"], {
    ref: "renewBasketPlanModal",
    "is-full-screen": true
  }, {
    default: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _cache[14] || (_cache[14] = _createElementVNode("p", { class: "title" }, "Renovar plano de cestas", -1 /* HOISTED */)),
        _createElementVNode("p", null, _toDisplayString($setup.pickupBranchId), 1 /* TEXT */),
        _cache[15] || (_cache[15] = _createElementVNode("div", { style: {"height":"16px"} }, null, -1 /* HOISTED */)),
        _createElementVNode("div", _hoisted_2, [
          _createVNode($setup["CommonInput"], {
            label: "Nome da cesta",
            state: "default",
            type: "text",
            "model-value": $setup.basketName,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = (v) => $setup.basketName = v),
            onTapTrailing: _cache[1] || (_cache[1] = ($event: any) => ($setup.basketName = ''))
          }, null, 8 /* PROPS */, ["model-value"]),
          _createVNode($setup["CommonInput"], {
            label: "ID da Nota Fiscal",
            state: "default",
            type: "text",
            "model-value": $setup.invoiceId,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = (v) => $setup.invoiceId = v),
            onTapTrailing: _cache[3] || (_cache[3] = ($event: any) => ($setup.invoiceId = ''))
          }, null, 8 /* PROPS */, ["model-value"]),
          _createVNode($setup["CommonInput"], {
            label: "Valor",
            state: "default",
            type: "text",
            mask: $setup.FormatUtils.formatMoney($setup.basketValue),
            "model-value": $setup.basketValue,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = (v) => $setup.basketValue = v),
            onTapTrailing: _cache[5] || (_cache[5] = ($event: any) => ($setup.basketValue = ''))
          }, null, 8 /* PROPS */, ["mask", "model-value"]),
          _createVNode($setup["DeliverySelector"], {
            ref: "deliverySelector",
            "branch-addresses": $setup.branchAddresses,
            "onUpdate:deliveryType": _cache[6] || (_cache[6] = ($event: any) => ($setup.deliveryType = $event)),
            "onUpdate:pickupBranchId": _cache[7] || (_cache[7] = ($event: any) => ($setup.pickupBranchId = $event)),
            "z-index": $setup.zIndex ? $setup.zIndex + 1 : undefined
          }, null, 8 /* PROPS */, ["branch-addresses", "z-index"])
        ]),
        _cache[16] || (_cache[16] = _createElementVNode("div", { style: {"height":"24px"} }, null, -1 /* HOISTED */)),
        _createElementVNode("div", _hoisted_3, [
          _cache[12] || (_cache[12] = _createElementVNode("p", null, "Data limite para personalização", -1 /* HOISTED */)),
          _createVNode($setup["Datepicker"], {
            modelValue: $setup.newLimitDate,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.newLimitDate) = $event)),
            "enable-time-picker": false,
            "min-date": $setup.tomorrow,
            "max-date": $setup.getMaxLimitDate(),
            teleport: true,
            locale: "pt-br",
            "month-name-format": "long",
            "day-names": $setup.FormatUtils.getDaysName(true),
            format: "dd/MM/yyyy",
            "select-text": "Selecionar",
            "cancel-text": "Cancelar"
          }, null, 8 /* PROPS */, ["modelValue", "min-date", "max-date", "day-names"])
        ]),
        _cache[17] || (_cache[17] = _createElementVNode("div", { style: {"height":"4px"} }, null, -1 /* HOISTED */)),
        _createElementVNode("div", _hoisted_4, [
          _cache[13] || (_cache[13] = _createElementVNode("p", null, "Data de entrega", -1 /* HOISTED */)),
          _createVNode($setup["Datepicker"], {
            modelValue: $setup.newDeliveryDate,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.newDeliveryDate) = $event)),
            "enable-time-picker": false,
            "min-date": $setup.getMinDeliveryDate(),
            label: "Nova data de entrega",
            teleport: true,
            locale: "pt-br",
            "month-name-format": "long",
            "day-names": $setup.FormatUtils.getDaysName(true),
            format: "dd/MM/yyyy",
            "select-text": "Selecionar",
            "cancel-text": "Cancelar"
          }, null, 8 /* PROPS */, ["modelValue", "min-date", "day-names"])
        ]),
        _cache[18] || (_cache[18] = _createElementVNode("div", { style: {"height":"24px"} }, null, -1 /* HOISTED */)),
        _createElementVNode("footer", _hoisted_5, [
          _createVNode($setup["CommonButton"], {
            type: "outlined",
            "border-radius": "small",
            action: "secondary",
            onClick: _cache[10] || (_cache[10] = ($event: any) => ($setup.renewBasketPlanModal?.close())),
            text: "Cancelar"
          }),
          _createVNode($setup["CommonButton"], {
            type: "filled",
            "border-radius": "small",
            onClick: _cache[11] || (_cache[11] = ($event: any) => ($setup.renewBasketPlan())),
            text: "Renovar"
          })
        ]),
        _cache[19] || (_cache[19] = _createElementVNode("div", { style: {"height":"4px"} }, null, -1 /* HOISTED */))
      ])
    ]),
    _: 1 /* STABLE */
  }, 512 /* NEED_PATCH */))
}